import { isMobile, isLogin } from './utils.js';

if (!isMobile) {
    let langue = `
    <div id="language" class="edition group">
        <a href="#" class="edition-item transition ">
            <span >CN</span>
            <img src="https://papu.yunshuren.com/images/cn.jpg" class="object-contain">
        </a>
        <a href="#" class="absolute edition-item transition">
            <span >EN</span>
            <img src="https://papu.yunshuren.com/images/en.jpg" class="object-contain">
        </a>
        </div>
    `
    $(langue).insertAfter($('#logo_area '))




    $('#nav ul').append('<div style="height: 3px" class="show-active absolute   transition-all duration-300"></div>')

    function moveToActiveNav() {
        var activeItem = $('#nav .active');
        $('#nav .show-active').css({
            left: activeItem[0].offsetLeft,
            width: activeItem[0].clientWidth
        })
    }
    moveToActiveNav()
    $('#nav ul').on('mouseover', 'li', function () {
        $('#nav .show-active').css({
            left: this.children[0].offsetLeft,
            width: this.children[0].clientWidth
        })
    })
    $('#nav ul').on('mouseleave', function () {
        moveToActiveNav()
    })
    const links = [
        {
            url: "https://znjscv.yunshuren.com/",
            pic: "https://papu.yunshuren.com/images/nav_smart.png",
        },
        {
            url: "https://xnycv.yunshuren.com/",
            pic: "https://papu.yunshuren.com/images/nav_ne.png",
        },
        {
            url: "https://www.yunshuren.com/product_wantbuy----.html",
            pic: "https://papu.yunshuren.com/images/nav_buy.png",
        },
        {
            url: "/go.php?to=qichejingwei",
            pic: "https://papu.yunshuren.com/images/nav_car.png",
        },
        {
            url: "https://union.yunshuren.com/",
            pic: "https://papu.yunshuren.com/images/nav_union.png",
        }
    ]
    let headerLinks = `<div class="flex  mr-0">`
    links.forEach(({ url, pic }) => {
        headerLinks += `<a href="${url}"><img src="${pic}"></a>`
    })
    headerLinks += '</div>'
    $('#header-nav').append(headerLinks)
    if (!isLogin()) {
        $(`
        <div id="login" class="ml-3">
            <a href="/login.html" class="relative user-login-item">
                <div class="default-icon">
                    <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="12" r="8" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M42 44C42 34.0589 33.9411 26 24 26C14.0589 26 6 34.0589 6 44" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <span class="">登录</span>
            </a>
        </div>
        `).insertBefore($('#header-nav'))
    }


    $("#tool").append(`
        <a class="w-16 h-16 text-ysr-green flex flex-col justify-center items-center gap-y-1" href="#header">
            <img src="https://papu.yunshuren.com//images/return_back.png" alt="返回顶部" loading="lazy">
        </a>
    `);
    $("#tool #compare-car").append(`
        <div class="absolute right-0 top-0 h-4 w-4 bg-red-600 rounded-full shadow">${compare_product_count }
        </div>
        `);

} else {
    $("#tool #compare-car").append(`
        <div class="">
            ${compare_product_count }
        </div>
    `);
    let menu = `
        <button id="mobile-header-toggle"  aria-label="nav item"> 
            <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48"><path stroke-linejoin="round" stroke-linecap="round" stroke-width="4" stroke="#20A196" d="M7.95 11.95h32M7.95 23.95h32M7.95 35.95h32" data-follow-stroke="#20A196"/></svg>
        </button>`;
    
    $('#header-nav').append(menu)

    if (!isLogin()) {
        $(`<div class="mobile_header_menu">
            <a href="/login.html" title="登录">
            <svg  viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="12" r="8" fill="none" stroke="#1ba196" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M42 44C42 34.0589 33.9411 26 24 26C14.0589 26 6 34.0589 6 44" stroke="#1ba196" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </a>
        </div>`).insertAfter('#header-nav')
    }

    
}


